import { axiosJSONInstance } from '@/config';
import {
  RoleRequest,
  TeamMemberRequest,
  TeamMemberResponse,
  RoleResponse,
  ResponseListType,
  Permission,
  PermissionResponse,
} from '@/types';

// Fetch TeamMember
export const fetchTeamMember = async (): Promise<TeamMemberResponse> => {
  const response = await axiosJSONInstance.get(`/merchants/users`);
  return response.data;
};

// Create TeamMember
export const createTeamMember = async (data: TeamMemberRequest): Promise<TeamMemberResponse> => {
  const response = await axiosJSONInstance.post(`/merchants/users`, data);
  return response.data;
};

// Fetch Role
export const fetchRoles = async (): Promise<RoleResponse> => {
  const response = await axiosJSONInstance.get(`/merchants/roles`);
  return response.data;
};

// Create Role
export const createRole = async (data: RoleRequest): Promise<RoleResponse> => {
  const response = await axiosJSONInstance.post(`/merchants/roles`, data);
  return response.data;
};

// Delete TeamMember
export const deleteTeamMember = async (uid: string): Promise<void> => {
  await axiosJSONInstance.delete(`/merchants/users/${uid}`);
};

// Delete Role
export const deleteRole = async (uid: string): Promise<void> => {
  await axiosJSONInstance.delete(`/merchants/roles/${uid}`);
};

// Update TeamMember
export const updateTeamMember = async (data: TeamMemberRequest): Promise<TeamMemberResponse> => {
  const response = await axiosJSONInstance.patch(`/merchants/users/${data.uid}`, data);
  return response.data;
};

// Update Role
export const updateRole = async (data: RoleRequest): Promise<RoleResponse> => {
  const response = await axiosJSONInstance.patch(`/merchants/roles/${data.uid}`, data);
  return response.data;
};

// Fetch Permission
export const fetchPermissions = async (): Promise<PermissionResponse> => {
  const response = await axiosJSONInstance.get(`/merchants/permissions`, {
    params: {
      perpage: 200,
      page: 1,
    },
  });
  return response.data;
};
